<template>
  <div id="page">
    <header :class="{showMenu:useOverlay}">
      <div v-if="useOverlay" class="control icon true" @mousedown.prevent="onMenuClick">
        <smart-icon icon="menu.svg"></smart-icon>
      </div>
      <div>Schreinerei Schill</div>
    </header>
    <smart-split-view
      id="sv"
      :pane-open="isPaneOpen || !useOverlay"
      :overlay-mode="useOverlay"
      :compact-mode="false"
      pane-width="250px"
    >
      <div slot="pane" class="scroll-y">
        <div class="grid v-fill-min">
          <nav ref="nav" tabindex="0" @focus="isPaneOpen=true" @blur="isPaneOpen=false">
            <router-link
              v-for="item in items"
              :key="item.name"
              tag="div"
              :to="item.link"
              class="control"
              exact
            >
              <smart-icon :icon="item.icon"></smart-icon>
              <div>{{item.title}}</div>
            </router-link>
          </nav>

          <nav>
            <a class="control" href="mailto:schreinerei-schill@t-online.de">
              <smart-icon icon="envelope.svg"></smart-icon>
              <div>schreinerei-schill@t-online.de</div>
            </a>
            <a class="control" href="tel:+49761402323">
              <smart-icon icon="phone-call.svg"></smart-icon>
              <div>0761 / 402323</div>
            </a>
            <a class="control" href="fax:+49761402907">
              <smart-icon icon="fax.svg"></smart-icon>
              <div>0761 / 402907</div>
            </a>
          </nav>
          </div>
      </div>
      <div class="content-container scroll-y" slot="content">
        <main>
          <router-view/>
        </main>
      </div>
    </smart-split-view>
  </div>
</template>

<script>
import pages from "@/pages.js";

export default {
  name: "App",
  data() {
    return {
      isPaneOpen: false,
      items: pages
    };
  },
  computed: {
    useOverlay() {
      var bp = this.$bpManager.breakpoints.md;
      if (bp) {
        // eslint-disable-next-line
        this.paneOpen = !bp.isBelow;
        return bp.isBelow;
      }
      return true;
    }
  },
  methods: {
    onMenuClick() {
      if (this.isPaneOpen) this.$refs.nav.blur();
      else this.$refs.nav.focus();
    },
    onPaneChange(value) {
      this.isPaneOpen = value;
    }
  }
};
</script>

<style>
#page {
  display: grid;
  grid-template-rows: 48px 1fr;
  width: 100vw;
  height: 100%;
}

#page > header {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr;
  grid-column-gap: 20px;
  font-family: "OrkneyBold";
  font-size: 1.6em;
  justify-items: center;
  align-items: center;
  box-shadow: 0 4px 16px rgb(150, 150, 150);
  background: var(--panel-background);
  z-index: 2;
}
#page > header.showMenu {
  grid-template-columns: 48px 1fr;
}

#sv{
  z-index: 2;
  --pane-background: var(--panel-background);
  --pane-border: 0 4px 16px rgb(150, 150, 150);
}

main {
  font-size: 1.2em;
  margin-bottom: 32px;
}

main *{
  overflow: visible;
}

#sv .content {
  position: relative;
}

#sv nav {
  display: grid;
  grid-auto-rows: var(--pane-compact-width);
  grid-row-gap: 4px;
  width: var(--pane-width);
  height: 100%;
  padding: 4px;
  outline: none;
  z-index: 3;
}

#sv nav > div,
#sv nav > a {
  display: grid;
  grid-template-columns: var(--pane-compact-width) 1fr;
  grid-column-gap: 4px;

  justify-items: center;
  align-items: center;

  padding: 0;
  cursor: pointer;

  text-decoration: inherit;
}

#sv nav > div > div:last-child,
#sv nav > a > div:last-child {
  justify-self: left;
}

#sv .pane{
  z-index: 999
}

#sv .pane > .scroll-y >div{
  min-height: 100%;
}

.icon {
  display: grid;
  width: 100%;
  height: 100%;

  justify-items: center;
  align-items: center;
}

header img,
nav > div img {
  width: 24px;
  height: 24px;
}

.footer{
  display: grid;
  grid-auto-rows: var(--pane-compact-width);
  grid-row-gap: 4px;
  width: var(--pane-width);

  padding: 4px;
  outline: none;
  z-index: 3;
}

.footer > div{
  
}

.footer a, .footer a:visited{
  color: inherit;
  text-decoration: inherit;
}
</style>
